module.exports = __webpack_public_path__ + "static/img/main-demonstrated.3a1aa663.png";